import { useFormContext } from 'react-hook-form'

import {
  FormDescription,
  FormError,
  FormField,
  FormItem,
  FormLabel,
  SearchSelect,
} from '@fortem-monorepo/react-ui'

import {
  AggregationFunction,
  AggregationFunctions,
  GuidelineFormValues,
} from '@/pages/funds/ic-guidelines-v2/components/edit-guideline-form/schema'

const NO_AGGREGATION = 'none'

const aggregateOptions = [
  { label: 'No aggregation', value: NO_AGGREGATION },
  ...AggregationFunctions.map((aggregate) => ({
    label: aggregate === 'sum' ? 'Sum matched rows' : aggregate,
    value: aggregate,
  })),
]

export const AggregateField: React.FC = () => {
  const { control, setValue } = useFormContext<GuidelineFormValues>()

  return (
    <FormField
      name="aggregation_function"
      control={control}
      render={({ field: { value } }) => (
        <FormItem>
          <div className="flex items-center gap-2 overflow-hidden">
            <FormLabel>Aggregation</FormLabel>
            <FormError />
          </div>
          <FormDescription>
            Choose whether matched rows should be evaluated individually or as a single combined
            value.
          </FormDescription>
          <SearchSelect
            value={value ?? NO_AGGREGATION}
            placeholder="Select aggregation..."
            setValue={(val) =>
              setValue(
                'aggregation_function',
                val === NO_AGGREGATION ? null : (val as AggregationFunction),
                {
                  shouldValidate: true,
                  shouldDirty: true,
                },
              )
            }
            options={aggregateOptions}
          />
        </FormItem>
      )}
    />
  )
}
